// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"loadingSpiner_spinnerContainer__LNbaG","loader":"loadingSpiner_loader__WF6xe","spin":"loadingSpiner_spin__vsve6"};